var e = {
	page: {
		title: "Claude (MCP) access",
		subtitle: "Connect your own Claude account to MAAT with a personal, expiring key. Claude can then answer read-only platform questions — pseudonymised, never contact, identity or bank details.",
		connect: "Connect Claude"
	},
	tabs: {
		mine: "My keys",
		all: "All admin keys"
	},
	row: {
		created: "Created {{when}}",
		expiresIn: "Expires in {{remaining}}",
		expiredOn: "Expired {{date}}",
		lastUsed: "Last used {{when}}",
		neverUsed: "Never used",
		owner: "Owner: {{owner}}",
		ownerYou: "You",
		actions: "Key actions",
		revoke: "Revoke"
	},
	revoke: {
		titleMine: "Revoke {{name}}?",
		titleOther: "Revoke another admin's key {{name}}?",
		bodyMine: "Claude stops answering through this key on its next request. This cannot be undone — mint a new key to reconnect.",
		bodyOther: "This key belongs to another admin. Their Claude connection stops on its next request, and they will need to mint a new key. This cannot be undone.",
		confirm: "Revoke",
		done: "Revoked {{name}}",
		error: "Could not revoke the key"
	},
	empty: {
		mine: {
			title: "Claude isn't connected yet",
			body: "Mint a key to ask read-only questions about bookings, finance and platform health from your own Claude account. Each key belongs to you alone and expires within 30 days."
		},
		all: {
			title: "No admin has connected Claude yet",
			body: "Every admin's keys appear here, so any admin can revoke one."
		}
	},
	loadError: {
		title: "Couldn't load MCP keys",
		retry: "Try again"
	},
	issue: {
		title: "Connect Claude",
		nameLabel: "Key name",
		namePlaceholder: "e.g. Claude Code on my laptop",
		nameHint: "How you'll recognise this key later. One key per device or client is easiest to revoke.",
		scopesLabel: "What Claude may read",
		scopesHint: "The connection itself is always included. Untick anything this client should not see.",
		expiryLabel: "Expires after",
		expiryOption_one: "{{count}} day",
		expiryOption_other: "{{count}} days",
		expiryHint: "A key lives at most {{max}} days. Mint a new one when it lapses.",
		bindingNote: "The key is bound to you. It stops working when it expires, when it is revoked, when your admin access ends, or if you have not signed in to the admin console recently.",
		submit: "Mint key",
		submitError: "Could not mint the key",
		validation: {
			nameRequired: "Give the key a name you'll recognise",
			nameTooLong: "Keep the name to {{max}} characters or fewer",
			scopesMin: "Choose at least one area Claude may read"
		},
		errors: {
			tooManyActiveKeys: "You have reached the limit of active keys. Revoke one you no longer use, then try again.",
			unavailable: "Claude access isn't switched on in this environment yet — an operator still has to configure it.",
			rateLimited: "Too many keys minted in the last minute. Wait a moment and try again."
		}
	},
	issued: {
		title: "Claude key minted",
		secretWarning: "This is the only time {{name}}'s secret will be shown. Copy it now — it is stored only as a hash and cannot be retrieved. If you lose it, revoke the key and mint a new one.",
		secretHint: "Your client sends it as an Authorization: Bearer header. Treat it like a password: never commit it or paste it into a shared chat.",
		done: "I've copied it — done"
	},
	connect: {
		title: "Connect a client",
		claudeCode: {
			title: "Claude Code",
			body: "Run this in a terminal:"
		},
		json: {
			title: "Claude Desktop and other MCP clients",
			body: "Add this to the client's MCP configuration:"
		},
		claudeAi: {
			title: "claude.ai",
			body: "Add a custom connector with this server URL, then add the request header below.",
			url: "Server URL",
			headerName: "Header name",
			headerValue: "Header value",
			note: "The custom-connector \"Request headers\" field may not be enabled on every claude.ai account yet. If you don't see it, use Claude Code or Claude Desktop instead."
		}
	}
};
//#endregion
export { e as default };
